import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import Footer from "../../Footer";
import swal from 'sweetalert'; // Import SweetAlert


function VideoCatagory(props) {
  const { token } = isAutheticated();
  const [data, setdata] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(15);
  const [showData, setShowData] = useState(data);


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      let res = await axios.get(`${API}/api/channel/view_all_channel`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log(res.data?.channels
      )
      setdata(res.data?.channels
      );
      setLoading(false);
    };
    fetchData();
  }, [success]);
  useEffect(() => {
    const loadData = () => {
      const indexOfLastPost = currentPage * itemPerPage;
      const indexOfFirstPost = indexOfLastPost - itemPerPage;
      setShowData(data.slice(indexOfFirstPost, indexOfLastPost));
    };

    loadData();
  }, [data, currentPage, itemPerPage]);
  const handleDelete = async (id) => {
    // Show SweetAlert confirmation
    const status = await swal({
      title: "Are you sure?",
      text: "Do you want to delete this Network Channel?",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });

    // If the user confirms, proceed with deletion
    if (!status) {
      return;
    }

    try {
      // Send delete request
      const res = await axios.delete(
        `${API}/api/channel/delete_channel/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res) {
        setSuccess(!success); // Trigger state update or re-fetch
        swal("Deleted!", "Network Channel has been deleted successfully.", "success");
      }
    } catch (error) {
      console.error("Error deleting Channel:", error);
      swal("Error", "There was an issue deleting the Channel.", "error");
    }
  };

  const handleToggleStatus = async (id, currentStatus) => {
    const action = currentStatus ? "suspend" : "activate";

    const confirm = await swal({
      title: `Are you sure?`,
      text: `Do you want to ${action} this Network channel?`,
      icon: "warning",
      buttons: ["Cancel", `Yes, ${action}`],
      dangerMode: true,
    });

    if (!confirm) return; // Exit if cancelled

    try {
      const res = await axios.patch(
        `${API}/api/channel/toggle-status/${id}`,
        { isActive: !currentStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res) {
        setSuccess((prev) => !prev); // Refresh data
        swal("Updated!", res.data.message, "success");
      }
    } catch (error) {
      console.error("Error toggling status:", error);
      swal("Error", "There was a problem updating the channel status.", "error");
    }
  };


  if (Loading) {
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="text-center p-4 border border-primary rounded shadow">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  }
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          {/* <!-- start page title --> */}

          <div className="row">
            <div className="col-12">
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0">Content Management - Network Channels</h4>

                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">SoComOTT</Link>
                    </li>
                    <li className="breadcrumb-item">
                      Content Management - Network Channels
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          {/* <!-- end page title --> */}

          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="row ml-0 mr-0  mb-10">
                    <div className="col-sm-12 col-md-6">&nbsp;</div>
                    <div className="col-sm-12 col-md-6">
                      <div className="dropdown d-block">
                        <Link to="/network_channel/add">
                          <button
                            type="button"
                            className="btn btn-primary add-btn waves-effect waves-light float-right"
                          >
                            <i className="fa fa-plus" aria-hidden="true"></i>{" "}
                            Add New Network Channel
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive table-shoot">
                    <table className="table table-centered table-nowrap mb-0">
                      <thead className="thead-light">
                        <tr className="text-center">
                          <th> Network Channel</th>
                          <th>Thumbnail</th>
                          <th>Banner</th>
                          <th>Logo</th>
                          <th>Status</th>



                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Loading ? (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#007bff" }}>
                                Loading...
                              </div>
                            </td>
                          </tr>
                        ) : showData?.length > 0 ? (
                          showData.map((item) => (
                            <tr key={item._id} className="text-center">
                              <td>{item.name}</td>
                              <td>
                                <img
                                  src={item?.thumbnail?.url}
                                  alt="thumbnail"
                                  style={{
                                    width: "90px", // Set desired width
                                    height: "50px", // Set desired height
                                    objectFit: "fill", // Maintain aspect ratio
                                    display: "block", // Center horizontally
                                    margin: "0 auto", // Center horizontally
                                  }}
                                />
                              </td>
                              <td>
                                <img
                                  src={item?.banner?.url}
                                  alt="banner"
                                  style={{
                                    width: "120px", // Set desired width
                                    height: "60px", // Set desired height
                                    objectFit: "fill", // Maintain aspect ratio
                                    // display: "block", // Center horizontally
                                    margin: "0 auto", // Center horizontally
                                  }}
                                />
                              </td>
                              <td>
                                <img
                                  src={item?.logo?.url}
                                  alt="logo"
                                  style={{
                                    width: "90px", // Set desired width
                                    height: "50px", // Set desired height
                                    objectFit: "fill", // Maintain aspect ratio
                                    display: "block", // Center horizontally
                                    margin: "0 auto", // Center horizontally
                                  }}
                                />
                              </td>
                              <td>
                                {/* {lession?.launchDate &&
                                  new Date(lession?.launchDate).toDateString()
                                } */}
                                {/* {console.log(lession?.video)}
                                  {lession?.video &&
                                    <button
                                      className="badge badge-pill badge-success font-size-12"
                                      onClick={() => downloadFile(lession?.video)}
                                    >
                                      Download
                                    </button>} */}



                                {item?.status ? (

                                  <span className='badge badge-pill badge-success font-size-12'>
                                    Live
                                  </span>
                                ) : (
                                  <span className='badge badge-pill badge-soft-danger font-size-12'>
                                    Suspend
                                  </span>
                                )}</td>

                              <td>
                                <button
                                  onClick={() => handleToggleStatus(item._id, item.status)}
                                  type="button"
                                  className={`btn btn-sm waves-effect waves-light btn-table me-2 ${item.status ? "btn-warning" : "btn-success"
                                    }`}
                                >
                                  {item.status ? "Suspend" : "Activate"}
                                </button>

                                <Link to={`/network_channel/edit/${item._id}`}>
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm waves-effect waves-light btn-table me-2"
                                  >
                                    Edit
                                  </button>
                                </Link>
                                <button
                                  onClick={() => handleDelete(item._id)}
                                  type="button"
                                  className="btn btn-danger btn-sm waves-effect waves-light btn-table"
                                  id="sa-params"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center py-4" style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#ff0000" }}>
                              No Channel Found. Please add Channel to display here.
                            </td>
                          </tr>
                        )}

                      </tbody>
                    </table>
                  </div>
                  {/* <!-- end table-responsive --> */}
                  <div className='row mt-20'>
                    <div className='col-sm-12 col-md-6 mb-20'>
                      <div
                        className='dataTables_info'
                        id='datatable_info'
                        role='status'
                        aria-live='polite'>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, data.length)} of{" "}
                        {data.length} entries
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_paginate paging_simple_numbers float-right'>
                        <ul className='pagination'>
                          <li
                            className={
                              currentPage === 1
                                ? "paginate_button page-item previous disabled"
                                : "paginate_button page-item previous"
                            }>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='0'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev - 1)
                              }>
                              Previous
                            </a>
                          </li>

                          {!(currentPage - 1 < 1) && (
                            <li className='paginate_button page-item'>
                              <a
                                aria-controls='datatable'
                                data-dt-idx='1'
                                tabIndex='0'
                                href='#'
                                className='page-link'
                                onClick={(e) =>
                                  setCurrentPage((prev) => prev - 1)
                                }>
                                {currentPage - 1}
                              </a>
                            </li>
                          )}

                          <li className='paginate_button page-item active'>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='2'
                              tabIndex='0'
                              className='page-link'>
                              {currentPage}
                            </a>
                          </li>

                          {!(
                            (currentPage + 1) * itemPerPage - itemPerPage >
                            data.length
                          ) && (
                              <li className='paginate_button page-item '>
                                <a
                                  href='#'
                                  aria-controls='datatable'
                                  data-dt-idx='3'
                                  tabIndex='0'
                                  className='page-link'
                                  onClick={() => {
                                    setCurrentPage((prev) => prev + 1);
                                  }}>
                                  {currentPage + 1}
                                </a>
                              </li>
                            )}

                          <li
                            className={
                              !(
                                (currentPage + 1) * itemPerPage - itemPerPage >
                                data.length
                              )
                                ? "paginate_button page-item next"
                                : "paginate_button page-item next disabled"
                            }>
                            <a
                              href='#'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev + 1)
                              }>
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- container-fluid --> */}
      </div>
      {/* <!-- End Page-content --> */}

      {/* <footer className="footer">
				<div className="container-fluid">
					<div className="row">
						<div className="col-sm-12">
							<script>document.write(new Date().getFullYear())</script> © SoComOTT
						</div>

					</div>
				</div>
			</footer> */}
      <Footer />
    </div>
  );
}

export default VideoCatagory;
